<template>
  <ul id="list-tasks">
    <li>

      <div id='oblea' v-show="it.tipoOblea == 1">
        <div id='s1'>
          <img :src="imagenProducto" style="width: 90%; height: 90%; object-fit: contain" /> 
        </div> 

        <div id='s2' :title="item.producto">
          <div class="fv lc">
            <div style="font-size: 11px; color: rgb(194, 126, 43); font-weight: 500;">{{codigoComp}}</div>
            <div id='titulo'>{{item.producto}}</div>
          </div> 
        </div> 

        <div id='s22'>
          <div>
            <span class='label'>Precio:</span> 
            <span class='value'>{{moneyLabel}} {{precioComp | formatMoney}}</span>
          </div>
          <div>
            <span class='label'>Subtotal:</span>
            <span class='value'>{{moneyLabel}} {{subtotalComp | formatMoney}}</span>
          </div>
        </div> 

        <div id='s3'>
          <div style=" margin-top: 27px;  margin-bottom: 3px">
           <span id='label-cantidad'>Cantidad</span> 
            <input class='cantidad' :class="{cantidadInv: cantInvalida}" type="text" v-model="it.cantidad" v-on:keyup="updateCantidad">
          </div>
          <div>
            <span class='error-msg' v-show="cantInvalida">{{errorMsg}}</span>
          </div>
          <span :class='{itemMaximoPorcentaje:esMultiploValido,itemMaximoPorcentajeInv:!esMultiploValido}' style="margin-top: 0px" v-show='showUnidadesDeVenta'>
              (Debe ser múltiplo de {{it.unidadesPorPedido}})
          </span>
          <span class='itemMaximoPorcentajeInv' style="margin-top: 0px" v-show='!esMultiploValido'>
              {{valorCercano}}
          </span>
        </div> 

        <div id='s4'>
          <img id='btnEliminarItem'  @click="btnEliminarItem"  src="/dist/icon-delete.png"  style= "width:20px;height:20px">   
        </div> 
      </div>


      <div id='oblea-desc' v-show="it.tipoOblea == 2" >
          <div id='s1'>
          </div> 
          <div id='s2'>
          <span id='titulo'>{{item.producto}}</span>
          </div> 
          <div id='s222'>
              <span class='value' style="margin-left: 60px">{{moneyLabel}} {{item.precioIngresado | formatMoney}}</span>
          </div> 
          <div id='s3'>
          </div> 
          <div id='s4'>
          </div> 
      </div>
  
    </li>
  </ul>
</template>


<script>
  import axios from 'axios'

  export default {
    name: 'item-pedido',
    props: ['item'],
    data()  {
       return {
         cantInvalida: false,
         it: this.item,
         valor:'',
        //  imagenProducto: null,
         errorMsg:''  
       }
    },



    computed: {
      moneyLabel() {
        if (this.$store.state.pedido.idMoneda == 2) {
          return 'U$S' 
        }
        else {
          return '$' 
        }
      },
      codigoComp() {
        if (! this.item.esPromo) {
           return 'Cod ' + this.item.codigo
        }
        else {
           return ''
        }
      },
      precioComp() {
        return (this.conversionMonedaProducto(this.item.precioIngresado)).toFixed(2)
      }, 
      subtotalComp() {
        return (this.conversionMonedaProducto(this.item.precioIngresado * this.it.cantidad)).toFixed(2)
      }, 
      showUnidadesDeVenta() {
        if (this.item.unidadesPorPedido > 1) {
          return true;
        }
        else {
          return false;
        }
      },
      esMultiploValido() {
        if (typeof this.item.unidadesPorPedido != 'undefined') {
            this.unidadesPedido = this.item.unidadesPorPedido
            if (typeof this.item.cantidad != 'undefined')  {
                var resto = this.item.cantidad % this.unidadesPedido
                if (resto == 0) {
                    if (this.item.cantidad == 0) {
                        this.multiploValido = false
                    }
                    else {
                        this.multiploValido = true
                    }
                } 
                else {
                    this.multiploValido = false
                }
                this.$store.commit('pedido/saveMultiploValido',this.multiploValido)         
            }
        }
        return this.multiploValido
      },
      valorCercano() {
        if (this.item.permiteDecimales) {
            return ''
        }
        else {
            if (typeof this.item.unidadesPorPedido != 'undefined') 
            {
               this.unidadesPedido = this.item.unidadesPorPedido
            }
            if (typeof this.item.cantidad != 'undefined') 
            {
               this.multiplo = Math.trunc(this.item.cantidad/this.item.unidadesPorPedido)  
            }
            var inf = this.multiplo*this.unidadesPedido
            var sup = (this.multiplo+1)*this.unidadesPedido
            if (inf<=0)
            {
                if (!isNaN(sup))
                {
                    return '(Valor cercano '+sup+')'  
                }
                else
                {
                    return ''
                }
            }
            else
            {
            if ((!isNaN(sup))&&(!isNaN(inf)))
                {
                    return '(Valores cercanos '+inf+' - '+sup+')'  
                }
                else
                {
                    return ''
                }
            }
        }
      },
      imagenProducto() {
        if (this.item.ImagenUrl != null) {
          return this.item.ImagenUrl
        }
        else {
          return '/dist/placeholder-producto.png'
        }
      } 
    },



    methods: {
      btnEliminarItem() {
        this.$emit('eliminarItem', this.item.id);
       },
      updateCantidad() {
        var rex = new RegExp(/^\d+$/);
        if (rex.test(this.it.cantidad))  
        {
          if (this.it.cantidad > 0)
          {
            if ((this.it.tieneLimiteMaximo) &&(this.it.cantidad > this.it.limiteMaximo)) {
                this.cantInvalida = true
                this.errorMsg = 'Máximo ' + this.it.limiteMaximo + ' por pedido'
            }
            else {
                this.cantInvalida = false
            }
          }
          else
          {
            this.cantInvalida = true
            this.errorMsg = 'Cantidad < 1'
          }
        }
        else
        {
          this.cantInvalida = true
          this.errorMsg = 'Cantidad invalida'
        }

        if (this.item.manejaStock)
        {
          if (Number(this.item.stockActual) < Number(this.it.cantidad))
          {
            this.errorMsg='Stock '+this.item.stockActual+' unidades'
            this.cantInvalida = true
          }               
        }

        if (Number(this.it.cantidad) < Math.ceil(this.item.pesoMinimoPedido/this.item.peso)) {
            this.errorMsg = 'Peso mínimo ' + this.item.pesoMinimoPedido +' Kg'
            this.cantInvalida = true
        }

        var itemUpdate = {
                          id: this.item.id,
                          idCategoria: this.item.idCategoria,
                          idSubcategoria: this.item.idSubcategoria,
                          producto: this.item.producto,
                          descripcion: this.item.descripcion,
                          precio: this.item.precio,
                          precioIngresado: this.item.precioIngresado,
                          detalle: this.detalle,
                          cantidad: parseInt(this.it.cantidad),
                          peso: this.item.peso,
                          archivoId: this.item.archivoId,
                          promocionId: this.item.promocionId, 
                          tipoOblea: this.item.tipoOblea,
                          diasEntrega:this.item.diasEntrega,
                          stockActual:this.item.stockActual,
                          manejaStock:this.item.manejaStock,
                          esPromo:this.item.esPromo,
                          tieneLimiteMaximo:this.item.tieneLimiteMaximo,
                          limiteMaximo:this.limiteMaximo,
                          codigo:this.productoSelect.codigo,
                          unidadesPorPedido:this.unidadesPorPedido,
                          pesoMinimoPedido:this.pesoMinimoPedido
                         }
  
        this.$store.commit('pedido/updateItemCarrito',itemUpdate)
      },
      conversionMonedaProducto(monto) {
        var montoConv = 0.0
        if (this.$store.state.pedido.idMoneda != this.$store.state.user.cliente.ListaPrecioMoneda) {
            if (this.$store.state.pedido.idMoneda == 2) {
                montoConv  = monto / this.$store.state.user.usuario.CotizacionDolar
            }
            else if (this.$store.state.pedido.idMoneda == 1) {
                montoConv  = monto * this.$store.state.user.usuario.CotizacionDolar
            }
        }
        else {
            montoConv  = monto 
        }
        return montoConv
      }
    },

    // mounted() {
    //     console.log('---------')
    //     console.log(this.item)
    //     console.log('---------')
        
    // }

  }
</script>


<style scoped>

* {
  margin:  0;
  padding: 0;
}


#oblea {
  width: 630px;
  height:85px;
  margin-bottom: 5px;
  background-color: #ffffff;  
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-shadow: 1px 1px 3px #dddddd;
  display: flex;
  align-items: flex-start; 
}

#oblea-desc {
  width: 630px;
  height:30px;
  margin-bottom: 5px;
  background-color: #ffffaa;  
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-shadow: 1px 1px 3px #dddddd;
  display: flex;
  align-items: flex-start; 
}



#s1{
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#s2{
  width: 40%;
  height: 100%;
  display: flex;
  align-items: center; 
}

#s22{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: flex-start; 
}

#s222{
  width: 24%;
  height: 100%;
  padding-left: 10px; 
  display: flex;
  flex-direction: row;
  justify-content: flex-start;  
  align-items: center; 
}

#s3{
  width: 20%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;  
  align-items: center;  
}

#s4{
  width: 6%;
  height: 100%;
  display: flex;
  justify-content: center;  
  align-items: center;  
}

#titulo{
  font-size: 13px;
  color: #656E76;
  font-weight: 500;
}


.label{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 60px;
  margin-top: 3px;
  margin-bottom: 3px;
}

.error-msg{
  font-size: 8px;
  color: #ff0000;
  float: left;
  margin-top: 5px;
}


.label-desc{
  font-size: 12px;
  color: #656E76;
  font-weight: 500;
  float: left;
  width: 70px;
}


.value{
  font-size: 12px;
  color: #656E76;
  float: left;
  margin-top: 3px;
  margin-bottom: 3px;
}

#label-subtotal{
  font-size: 12px;
  color: #656E76;
  margin-left: 10%;
}


#label-cantidad {
 font-size: 12px;
 color: #656E76;
 font-weight: 500;
 }


.cantidad {
  width: 40px;
  height: 22px;
  margin-left: 5px;
  border-radius: 4px;  
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
  text-align: center;
  color: #656E76;
  outline: none;
  }


.cantidadInv {
  width: 40px;
  height: 22px;
  margin-left: 5px;
  border-radius: 4px;  
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #ff0000;
  text-align: center;
  color: #656E76;
  outline: none;
  }




.itemMaximoPorcentaje{
  font-size: 8px; 
  color: #5C666F;
  display: flex;
  align-items: flex-end
}

.itemMaximoPorcentajeInv{
  font-size: 8px; 
  color: #FF0000;
  display: flex;
  align-items: flex-end
}


#btnEliminarItem:hover{
  cursor: pointer;  
}


 </style>


// WEBPACK FOOTER //
// src/components/views/pedido/ItemPedido.vue